export function dollarsToCents(dollars: number | null): number | null {
  return typeof dollars === 'number' ? Math.round(dollars * 100) : null;
}

export function centsToDollars(
  cents: number | null | undefined
): number | null {
  return typeof cents === 'number' ? cents / 100 : null;
}
